/* istanbul ignore file */
import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout, DateTimeRangeFilter } from 'framework/list';
import React from 'react';
import useCrmNoteItem from 'domain/sales/shared/timeline/note/crmNoteRegistry';
import { Show } from 'framework/show';
import { Timeline, TimelinePageLayout, TimelineLayout } from 'framework/ui/timeline';
import { useContactId } from 'domain/sales/contact/contactRouting';
import ContactEntityHeader from 'domain/sales/contact/shared/ContactEntityHeader';
import useContactService from 'domain/sales/contact/shared/contactService';
import ContactsMenu from 'domain/sales/contact/shared/ContactsMenu';
import ContactTimelineBreadcrumbs from 'domain/sales/contact/Timeline/Breadcrumbs';

const ContactTimelinePage = () => {
  const contactId = useContactId();
  const {
    getById,
    searchTimelineItems,
    createTimelineItem,
    getTimelinePageById,
    getFilterValidationSchema,
    pinContactTimeline,
  } = useContactService();

  const noteRegistry = useCrmNoteItem();

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <DateTimeRangeFilter label="Created date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );
  return (
    <Show getDataMethod={() => getById(contactId)}>
      <Timeline
        registries={[noteRegistry] as any}
        getDataMethod={request => searchTimelineItems(contactId, request)}
        pinTimelineAction={pinContactTimeline}
        createTimelineItemMethod={(itemType, request) => createTimelineItem(contactId, itemType, request) as any}
        getPageByEntryIdMethod={id => getTimelinePageById(contactId, id)}
      >
        <TimelinePageLayout
          menu={<ContactsMenu />}
          breadcrumbs={<ContactTimelineBreadcrumbs />}
          entityHeader={<ContactEntityHeader />}
          titleVariant="h4"
          filter={filters}
        >
          <TimelineLayout noEntriesMessage="No entries in this contact timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default ContactTimelinePage;
